import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, catchError, of, switchMap } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { LoginService } from '@app/services';

@Injectable()
export class AuthRequestInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private login: LoginService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const bearer = request.headers.get('Authorization');

    if (bearer?.length > 0) {
      if (localStorage.getItem('sso_logged_out') == 'true') {
        console.info('colbi sso logged out. Logging out.');
        const currentPath = window.location.pathname;
        this.authService.logout({
          logoutParams: {
            returnTo: encodeURI(
              window.location.origin +
                '/auth-msg?message=You have been logged out of QualityBidders from another domain. Please log in again.&redirect=' +
                currentPath
            ),
          },
        });
        localStorage.removeItem('sso_logged_out');
        return of();
      }

      // Configure token lifetime based on user type
      const tokenOptions = this.login.isQbat
        ? { authorizationParams: { max_age: 60 } } // 1 minute for QBAT
        : { authorizationParams: { max_age: 900 } }; // 15 minutes for others

      return this.authService.getAccessTokenSilently(tokenOptions).pipe(
        catchError(err => {
          if (err.error == 'login_required') {
            const currentPath = window.location.pathname;
            this.authService.logout({
              logoutParams: {
                returnTo: encodeURI(
                  window.location.origin +
                    '/auth-msg?message=You have been logged out of QualityBidders. Please log in again.&redirect=' +
                    currentPath
                ),
              },
            });
          }
          throw err;
        }),
        switchMap(accessToken => {
          request.headers.set('Authorization', 'Bearer ' + accessToken);
          return next.handle(request);
        })
      );
    }
    return next.handle(request);
  }
}
